var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupiedBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.084 11.2559C10.084 14.5755 11.0297 16.9619 12.6782 20.0972L13.4361 19.6989C11.8497 16.6823 10.9402 14.4409 10.9402 11.2559H10.084Z",
    fill: "#BE1E2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97363 5.23121V6.32951H12.1952V5.23121C12.1952 5.18385 12.1567 5.14569 12.1096 5.14569H9.05916C9.01179 5.14569 8.97363 5.18418 8.97363 5.23121Z",
    fill: "#BE1E2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1952 9.14255V7.18542H8.97363V9.14255C8.97363 9.18992 9.01212 9.22807 9.05916 9.22807H12.1096C12.157 9.22807 12.1952 9.18959 12.1952 9.14255Z",
    fill: "#BE1E2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5019 10.0842H9.66943V10.7841H11.5019V10.0842Z",
    fill: "#BE1E2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64038 2.8202C2.64104 2.30017 3.0624 1.87881 3.58211 1.87848H9.1933C9.71334 1.87914 10.1347 2.3005 10.135 2.8202V4.70398H10.9912V2.8202C10.9902 1.8275 10.1857 1.02326 9.1933 1.02228H3.58211C2.5894 1.02326 1.78517 1.82782 1.78418 2.8202V25.7252H2.64038V2.8202Z",
    fill: "#BE1E2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49838 26.162V27.9599C1.49903 28.48 1.92039 28.9013 2.4401 28.9016H37.8019C38.322 28.901 38.7433 28.4796 38.7437 27.9599V26.162H1.49805H1.49838Z",
    fill: "#BE1E2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9292 22.8004C11.7477 22.8017 10.7899 23.7592 10.7886 24.941V25.3058H19.8789V25.2834C20.5647 25.2834 21.1202 24.7275 21.1202 24.0421C21.1202 23.3566 20.5643 22.8007 19.8789 22.8007H12.9292V22.8004Z",
    fill: "#BE1E2D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1201 36.9528C33.2689 36.9528 32.5791 37.6429 32.5791 38.4938C32.5791 39.3447 33.2692 40.0348 34.1201 40.0348C34.9711 40.0348 35.6612 39.3447 35.6612 38.4938C35.6605 37.6429 34.9707 36.9534 34.1201 36.9528Z",
    fill: "#BE1E2D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8346 22.8003C11.3935 22.2513 12.1458 21.9438 12.9293 21.9441H19.8789C21.0367 21.9434 21.9758 22.8812 21.9765 24.039C21.9765 24.4963 21.8274 24.941 21.5515 25.3057H36.623L35.7464 23.3483C34.9257 21.5191 33.1081 20.3415 31.1029 20.3399H13.7667C12.3224 20.3419 11.0869 21.3787 10.834 22.8006L10.8346 22.8003Z",
    fill: "#BE1E2D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07747 24.0501C9.03908 23.0884 9.03907 21.5294 8.07746 20.5677C7.11585 19.6061 5.55677 19.6061 4.59516 20.5677C3.63355 21.5294 3.63355 23.0884 4.59516 24.0501C5.55677 25.0117 7.11585 25.0117 8.07747 24.0501Z",
    fill: "#BE1E2D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7566 29.7582H13.4854V33.0119H26.7566V29.7582Z",
    fill: "#BE1E2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1216 36.9528C5.27033 36.9528 4.58057 37.6429 4.58057 38.4938C4.58057 39.3447 5.27066 40.0348 6.1216 40.0348C6.97254 40.0348 7.66263 39.3447 7.66263 38.4938C7.66197 37.6429 6.97221 36.9534 6.1216 36.9528Z",
    fill: "#BE1E2D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55029 34.8098V35.9229H33.6925V34.8098C33.6919 34.2897 33.2705 33.8687 32.7508 33.868H7.49234C6.97231 33.8687 6.55128 34.2901 6.55062 34.8098H6.55029Z",
    fill: "#BE1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupiedBed);
export default __webpack_public_path__ + "static/media/OccupiedBed.26aa2b9b12bfc87ba8b2a76007c35944.svg";
export { ForwardRef as ReactComponent };